// Messages browsers use when a code-split chunk can't be fetched, typically
// because a deploy replaced it while the tab was open.
const CHUNK_LOAD_ERROR_PATTERNS = [
  /dynamically imported module/i,
  /loading dynamically imported module/i,
  /failed to fetch.*\.(js|css)/i,
  /importing a module script failed/i,
  /error loading module/i,
];

export function isChunkLoadError(errorMessage: string): boolean {
  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) =>
    pattern.test(errorMessage),
  );
}

export function errorMessageOf(error: unknown): string {
  if (typeof error === "string") return error;
  if (error instanceof Error) return error.message;
  return "";
}
